import "vanilla-cookieconsent/dist/cookieconsent.css";
import "../../styles/index.scss";

import { Slice } from "gatsby";
import i18next from "i18next";
import * as React from "react";
import { I18nextProvider } from "react-i18next";

import {
  DEFAULT_LANGUAGE,
  LANGUAGE,
} from "../../../../company/settings/translations";
import global_en from "../../translations/en/global.json";
import global_es from "../../translations/es_ES/global.json";
import Debugger from "../Debugger/Debugger";
import Header from "./Header/Header";

interface Props {
  classNames?: string;
  children: React.ReactNode;
  language?: LANGUAGE;
}

const Layout: React.FC<Props> = (props: Props): JSX.Element => {
  const lng = props.language || DEFAULT_LANGUAGE;
  i18next.init({
    interpolation: { escapeValue: false },
    lng,
    resources: {
      es: {
        global: global_es,
      },
      en: {
        global: global_en,
      },
    },
  });
  return (
    <I18nextProvider i18n={i18next}>
      <div className={props.classNames}>
        <Header />
        {props.children}
        <Slice alias={`contactUs`} />
        <Slice alias="footer" />
        <Debugger />
      </div>
    </I18nextProvider>
  );
};

export default Layout;
